import styles from "@styles/containers/cdp/audiences.module.scss";
import { useEffect } from "react";

import * as echarts from "echarts";

export default function MonthChart({ data }) {
  useEffect(() => {
    if (typeof window !== "undefined") {
      const monthChartDOM = document.getElementById("month-chart");
      const monthChart = echarts.init(monthChartDOM, null, {
        renderer: "svg",
      });
      
      const options = {
        tooltip: {
          show: false,
        },
        xAxis: {
          type: "category",
          data: (data || []).map(d => d.day),
        },
        yAxis: {
          splitLine: {
            show: false,
          },
          type: "value",
        },
        series: [
          {
            name: "",
            type: "line",
            data: (data || []).map(d => d.customers),
            showSymbol: true,
            linestyles: {
              width: 2,
              color: "#5448C5",
            },
            markPoint: {
              symbol: "roundRect",
              symbolSize: 35,
              label: {
                color: "#fff",
              },
              data: (data || []).map((d, i) => ({ coord: [i, d.customers], value: d.customers })),
            },
          },
        ],
      };

      options && monthChart.setOption(options);
    }
  }, [data]);

  return (
    <div className={styles.monthChartContainer}>
      <div className={styles.chartHeader}>
        <p>Últimos 30 dias</p>
      </div>
      <div id="month-chart" style={{ width: "100%", height: "calc(100% - 35px)" }} />
    </div>
  );
}
